import React, { useEffect, useState } from "react";
import { useSubheader } from "@metronic/layout";
import { Alert } from "react-bootstrap";
import Pagination from "react-js-pagination";
import GeneralFilter from "@components/shared/general-filter";
import GeneralTable from "@components/shared/general-table";
import { getCasesByStatuses } from "@services/cases";
import CaseContext from "@contexts/case-context";
import { IfHasRoleByLocalStorage } from "@metronic/_helpers";

const StorePatient = () => {
  window.currModule = "Alta Paciente";
  window.assignationColumn = "feaapaciente";

  const subheader = useSubheader();

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });

  const getAllCasesByStatus = (pageNumber) => {
    var queryParams = [];

    if (IfHasRoleByLocalStorage("ADMIN_REGION_CELULA")) {
      queryParams = ['&byRegion=true', '&byCell=true'];
    }

    getCasesByStatuses([7], pageNumber, queryParams).then((response) => {
      setCasesRecord(response.data);
      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  }

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  }

  useEffect(() => {
    subheader.setTitle("Alta Paciente");

    getAllCasesByStatus(paramsPagination.activePage);

    
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Alta Paciente
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={[7]}
          hideAxaCategoryId={true}
          hideStatusPatient={false}
          hideCategoryVip={true}
        />
      </CaseContext.Provider>

      <GeneralTable
        urlToGo="/alta_paciente_detalles/"
        data={casesRecord}
        activePage={paramsPagination.activePage}
        totalItemsCount={paramsPagination.totalItemsCount}
        hideAssignedDoctorColumn={true}
        hideAssignedNurseColumn={true}
        hideAssignedConciergeColumn={true}
        hideAxaCategoryColumn={true}
        hideHospitalDateTimeHireColumn={true}
        hideTabulationColumn={true}
        hidePolicyTypeColumn={true}
        reason="Dictum"
        reasonTitle="Estatus Dictamen Medico"
        currModule="Alta Paciente"
        statusTitle="Estatus Control de Costos"
        assignationColumn="feaapaciente"
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default StorePatient;

